// import '~/js/sections/weddings/includes/stickyNav';
import "~/js/libs/jquery-ui.selectmenu.min.js";
import "slick-carousel";
import "~/js/libs/jquery.waypoint";
import "~/js/libs/sticky";

// Variable Declaration
const resortMenu = document.getElementById("resort-menu");
const toggleButton = document.getElementById("resort-menu-click");
const isFixedNav = resortMenu.classList.contains("fixed-resort-menu");
let waypoint;

// Internals Variables
const internals = {
  options: {
    element: resortMenu,
    offset: 0,
    stuckClass: "stuck",
  },
};

// Sticky Nav
if (!isFixedNav) {
  waypoint = new window.Waypoint.Sticky(internals.options);
}

// Toggle Sticky Nav
toggleButton.addEventListener("click", () =>
  resortMenu.classList.toggle("open")
);
document.body.addEventListener("click", (event) => {
  if (
    $(event.target).parents("#resort-menu").length <= 0 &&
    resortMenu.classList.contains("open")
  ) {
    resortMenu.classList.remove("open");
  }
});

const stickyNav = _globalUtils.debounce(() => {
  if (window.pageYOffset <= waypoint.waypoint.triggerPoint) {
    if (window.innerWidth > 767) {
      if (resortMenu.classList.contains("stuck")) {
        resortMenu.classList.remove("stuck");
      }
    }
  }
}, 300);

window.addEventListener("resize", stickyNav);

$(document).ready(function () {
  $("ul.tabs li").click(function () {
    var tab_id = $(this).attr("data-tab");

    $("ul.tabs li").removeClass("current");
    $(".tab-content").removeClass("current");

    $(this).addClass("current");
    $("#" + tab_id).addClass("current");
  });
});
